module.exports = {
    "Terminal Programları": "Terminal Programs",
    "menu.KullaniciVeRolYonetimi": "User and Role Management",
    "menu.KullaniciYonetimi": "User Management",
    "menu.KullaniciRolYonetimi": "User Role Management",
    "menu.YetkiGrupYonetimi": "Permission Group Management",

    "1- Araç Sorgulama": "1- Vehicle Inquiry",
    "2- Liman Giriş": "2- Port Entry",
    "3- Limandan Depoya Sevkiyat": "3- Shipment from Port to Warehouse",
    "4- Tekli Grupaj Tır Eşleme": "4- Single Groupage Truck Matching",
    "5- Depolar Arası Transfer": "5- Inter-Warehouse Transfer",
    "6- Depo Giriş": "6- Warehouse Entry",
    "7- Gemi Araç Giriş": "7- Ship Vehicle Entry",
    "8- Antrepo Çıkış": "8- Entrepot Exit",
    "9- PDI Giriş": "9- PDI Entry",
    "10- PDI Dönüş": "10- PDI Return",
    "11- PDI Yapılmayacak": "11- PDI Not to be Done",
    "12- Gümrüklü Alan'a İade": "12- Return to Customs Area",
    "13- PDI Çıkış": "13- PDI Exit",
    "14- Hasarlıdan Çıkış": "14- Exit from Damaged",
    "15- Sevk Alanına Transfer": "15- Transfer to Shipment Area",
    "16- Peron Kontrol": "16- Platform Control",
    "17- Şase İle Kapı Çıkış": "17- Chassis Exit with Gate",
    "18- Tır Onay": "18- Truck Approval",
    "19- Depo Çıkış": "19- Warehouse Exit",
    "20- Otomatik Adres Değiştir": "20- Automatic Address Change",
    "21- Yerinde Adresleme": "21- On-Site Addressing",
    "22- Sayım": "22- Inventory Count",
    "23- Yazıcı Seçimi": "23- Printer Selection",
    "24- Etiket Yazdır": "24- Print Label",

    "sifremiDegistir": "Change My Password",
    "cikisYap": "Log Out",

    "Araç Bilgileri": "Vehicle Information",
    "Giriş-Çıkış Tarihleri": "Entry-Exit Dates",
    "Araç Hareketleri": "Vehicle Movements",
    "Emirler": "Orders",
    "Sevkiyet Hareketleri": "Shipment Movements",
    "Hasarlar": "Damages",
    "Blokaj": "Blockage",
    "Tarihçe": "History",
    "Şase": "VIN",
    "Bul": "Find",
    "Marka": "Brand",
    "Model": "Model",
    "PDI Durumu": "PDI Status",

    "Fatura Tarih": "Invoice Date",
    "Fatura No": "Invoice No",
    "Fatura Bayi": "Invoice Dealer",

    "Millileşme Durumu": "Nationalization Status",
    "Park Adres": "Park Address",
    "Noas Ref": "Noas Ref",
    "Durum": "Status",
    "Son Yapılan İşlem Tarihi": "Last Transaction Date",
    "Renk": "Color",
    "Son İşlem": "Last Transaction",

    "No Data": "No Data",

    "Türkiye Liman Giriş": "Turkey Port Entry",
    "Türkiye Liman Çıkış": "Turkey Port Exit",
    "Antrepo Giriş": "Fictitious Entry",
    "Antrepo Çıkış": "Fictitious Exit",
    "Son Depo Giriş": "Last Warehouse Entry",
    "Son Depo Çıkış": "Last Warehouse Exit",

    "Şase Sorgulama": "VIN Inquiry",


    "Tarih": "Date",
    "Hareket Tipi": "Movement Type",
    "HareketKodu": "Movement Code",
    "HareketAdı": "Movement Name",
    "Nereden": "From",
    "Nereye": "To",
    "BulunduguAdres": "Current Address",
    "GittigiYer": "Destination",
    "ParkSoforu": "Park Driver",
    "IslemYapanKullanici": "User",

    "Giriş Tarih": "Entry Date",
    "Gerçekleşme": "Realization",
    "Emir Kodu": "Order Code",
    "Emir Adı": "Order Name",
    "Emir Durumu": "Order Status",
    "Emir Oluşturan": "Order Creator",

    "GrupajNo": "Groupage No",
    "Rota": "Route",
    "Grupaj Tarih": "Groupage Date",
    "Kapı Çıkış Tarih": "Gate Exit Date",
    "Taşıyıcı": "Carrier",
    "Tır Plaka": "Truck Plate",
    "Şoför": "Driver",
    "Grupaj Statü": "Groupage Status",
    "Fatura Tarihi": "Invoice Date",

    "Hasar Giriş": "Damage Entry",
    "İşlem Tarihi": "Transaction Date",
    "Hasar Yeri": "Damage Location",
    "Hasar Detay": "Damage Detail",
    "Hasar Sorumlusu": "Damage Responsible",
    "Hasar Durumu": "Damage Status",
    "Kaydı Oluşturan": "Created By",

    "Blokaj No": "Blockage No",
    "Blokaj Açıklama": "Blockage Description",
    "Aktif/Pasif": "Active/Passive",
    "Kodlama Tarihi": "Coding Date",
    "Kodlayan": "Coder",
    "Kaldırma Tarihi": "Removal Date",
    "İptal Eden": "Cancelled By",

    "Dosya Adı": "File Name",
    "Yükleme Tarih": "Upload Date",
    "Yükleyen": "Uploader",
    "Durum Kodu": "Status Code",
    "Durum Açıklama": "Status Description",
    "Olay Adı": "Event Name",

    "Operasyonlar": "Operations",

    "Araç Sorgulama": "Vehicle Inquiry",
    "Şase No Giriniz": "Enter VIN No",

    "Tamam": "OK",
    "Liman Giriş": "Port Entry",
    "Ara": "Search",

    "Operasyon İzleme": "Operation Tracking",
    "Excel Toplu İşlemler": "Excel Bulk Operations",
    "Hasar Bildirimi": "Damage Notification",
    "Gemi İşlemleri": "Ship Operations",
    "Stok İzleme": "Stock Tracking",

    "Hasar Açıklama": "Damage Description",
    "Bölge": "Region",
    "Bildiren Kişi": "Notifier",
    "Hasar Görseli": "Damage Image",

    "Hasar Bildir": "Report Damage",
    "Listele": "List",

    "PDI Giriş": "PDI Entry",
    "PDI Dönüş": "PDI Return",
    "PDI Çıkış": "PDI Exit",

    "Etiket Yazdır": "Print Label",
    "PDI Yapılmayacak": "PDI Not to be Done",
    "Rıhtım'a İade": "Return to Dock",

    "Hasarlıdan Çıkış": "Exit from Damaged",
    "Sevke Hazırlama": "Prepare for Shipment",

    "Yazıcı Seçimi": "Printer Selection",
    "Çalıştığınız Depo": "Your Warehouse",
    "Kullanılan Yazıcı Seçiniz": "Select Printer",
    "Kaydet": "Save",

    "Peron Kontrol": "Platform Control",
    "Gemi Araç Giriş": "Ship Vehicle Entry",

    "Toplam Stok": "Total Stock",
    "Faturlanmış / Sevk Emri Olan": "Invoiced / Shipped Order",
    "Faturalanmamış / Sevk Emri Olmayan": "Uninvoiced / No Shipment Order",
    "Blokajlı": "Blocked",

    "Sevk Edilebilir Araç Sayısı": "Number of Shippable Vehicles",
    "Depo": "Warehouse",

    "Bayi Sevk": "Dealer Shipment",
    "Depolar Arası Transfer": "Inter-Warehouse Transfer",
    "Son 7 Gün Depo Çıkış Adetleri": "Last 7 Days Warehouse Exit Quantities",

    "Grupaj Operasyonları": "Groupage Operations",
    "Grupaj Operasyonları Detay": "Groupage Operations Detail",

    "Depo Çıkış": " Warehouse Exit",
    "Grupaj No Giriniz": "Enter Groupage No",

    "Hasar Tarihi": "Damage Date",
    "Hasar Bildirilen Bölge": "Region of Damage",
    "İptal": "Cancel",

    "Faturalanmış / Sevk Emri Olan": "Invoiced / Shipped Order",

    "equal": "Equals",
    "greaterThan": "Greater than",
    "greaterThanOrEqual": "Greater than or equal to",
    "lessThan": "Less than",
    "lessThanOrEqual": "Less than or equal to",
    "notContains": "Does not contain",
    "notEqual": "Does not equal",
    "startswith": "Starts with",
    "endsWith": "Ends with",
    "between": "Between",
    "contains": "Contains",
    "endswith": "Ends with",
    "tümü": "(All)",
    "Filtrele": "Filter",

    "Yüklemek İstediğiniz Excel Dosyasını seçiniz. Excel Şablonunu": "Please select the Excel file you want to upload. You can download the Excel template",
    "buradan": "here",
    "indirebilirsiniz": "from here",
    "Excel Dosyası Yükle": "Upload Excel File",
    "vehicleData cannot be nil": "vehicleData cannot be nil",
    "chassisNo number is required": "chassisNo number is required",
    "chassisNo number must be 17 characters": "chassisNo number must be 17 characters",
    "user ID is required": "user ID is required",
    "type is required": "type is required",
    "data is required": "data is required",

    "no vehicle found with chassis number": "No vehicle found with chassis number",
    "multiple vehicles found with chassis number": "Multiple vehicles found with chassis number",

    "PDI order has not been issued for this vehicle": "PDI order has not been issued for this vehicle",
    "Vehicle not found": "Vehicle not found",
    "Invalid vehicle status": "Invalid vehicle status",
    "PDI entry has already been processed for this vehicle": "PDI entry has already been processed for this vehicle",
    "Internal server error": "Internal server error",
    "Yükleniyor": "Loading",

    "PDI entry not found for this vehicle": "PDI entry not found for this vehicle",
    "PDI entry process not completed": "PDI entry process not completed",
    "PDI exit already processed for this vehicle": "PDI exit already processed for this vehicle",
    "multiple vehicles found with same chassis number": "multiple vehicles found with same chassis number",
    "PDI entry already processed for this vehicle": "PDI entry already processed for this vehicle",
    "invalid vehicle status": "invalid vehicle status",
    "vehicle not found": "vehicle not found. Please check the VIN number.",
    "Beklenmedik bir hata oluştu.": "An unexpected error occurred.",
    "Invalid request format": "Invalid request format",
    "merge error: PDI status is already YENI": "An active PDI order already exists for this vehicle.",
    "failed to check vehicle existence: vehicle not found": "Vehicle not found",
    "merge error: PDI status is already IPTAL": "A cancelled PDI order already exists for this vehicle.",

    "Kullanıcı Yönetimi": "User Management",
    "Ad Soyad": "Name Surname",
    "Kullanıcı Adı": "Username",
    "Aktif": "Active",
    "İşlem": "Action",
    "Yeni Kayıt": "New Record",
    "Toplam": "Total",
    "Yeni Kayıt Formu": "New Record Form",
    "Kullanıcı Bilgileri": "User Information",
    "Yetkilendirme": "Authorization",
    "Lütfen Ad Soyad giriniz.": "Please enter Name Surname.",

    "Cinsiyet": "Gender",
    "Cinsiyet Seçiniz": "Select Gender",
    "Lütfen Kullanıcı Adı giriniz.": "Please enter Username.",
    "Lütfen Email giriniz.": "Please enter Email.",

    "Sadece Görme Yetkisi": "Only View Authorization",
    "Sadece Ekleme Yetkisi": "Only Add Authorization",
    "Sadece Güncelleme Yetkisi": "Only Update",
    "Sadece Silme Yetkisi": "Only Delete Authorization",
    "Sadece Excel Export Yetkisi": "Only Excel Export Authorization",
    "Tüm Özel Rolleri Kaldır": "Remove All Special Roles",
    "Lütfen Kullanıcı seçiniz": "Please select User",

    "marked_roles": "*Marked roles",
    "in_selected_role_group": "'In Selected Role Group'",
    "defined_roles": "are defined roles. Selected other roles are added to the person as",
    "special_role": "'Special Role'",
    "as_special_role": ".",

    "Yetki Grubu Adı": "Permission Group Name",
    "Rol Adı": "Role Name",
    "Geri": "Back",

    "Gruplamak için sütun başlığını buraya sürükleyin": "Drag the column title here to group",
    "Bu sütuna göre grupla": "Group by this column",
    "Devamı için buraya tıklayın": "Click here for more",
    "Grubu çöz": "Ungroup",
    "Tüm grupları çöz": "Ungroup All",
    "Özel Roller": "Special Roles",
    "Yetki Grupları": "Permission Groups",
    "Şifre": "Password",
    "Şifre Tekrarı": "Password Repeat",
    "Lütfen Şifre giriniz": "Please enter Password",
    "Şifre belirlemeyecekseniz şifre alanlarını boş bırakınız.": "If you do not want to set a password, leave the password fields blank.",
    "Lütfen Şifre Tekrarı giriniz": "Please enter Password Repeat",

    "inactive_user_message": "The email you entered belongs to a user who is",
    "inactive_user": "not active",
    "continue_message": "in the system. If you wish to activate this user and continue, please",
    "activate_user": "activate the user",
    "or_different_email": "or continue with a different email address.",
    "İleri": "Next",

    "Toplu Kullanıcı Yetki Grubu Atama": "Bulk User Role Assignment",
    "Kullanıcı Rol Yönetimi": "User Role Management",
    "Seçim": "Selection",
    "Kullanıcı Yetki Grubu Atama Formu": "User Role Assignment Form",
    "Yetki Grubu Güncelleme Formu": "Permission Group Update Form",

    "Yetki Grup Yönetimi": "Permission Group Management",
    "Yetki Grubu Oluştur": "Create Permission Group",

    "Grup Bilgileri": "Group Information",
    "Yeni Yetki Grubu Oluşturma Formu": "New Permission Group Creation Form",
    "Roller": "Roles",
    "17 karakterli şase numarası giriniz": "Please enter a 17-character VIN number",
    "Lütfen hasar açıklaması giriniz": "Please enter a damage description",

    "please": "Please",
    "enter": "enter",
    "Lütfen Adres Tarifi Giriniz": "Please enter Address Description",
    "Lütfen Adres Seçiniz": "Please select Address",

    "Depo Tanım": "Warehouse Definition",
    "Depo Kodu": "Warehouse Code",
    "Depo Kısa Adı": "Warehouse Short Name",
    "Kapasite": "Capacity",
    "Vergi Dairesi": "Tax Office",
    "Vergi No": "Tax No",
    "Depo Ekle": "Add Warehouse",
    "Depo Adı": "Warehouse Name",
    "Ekle": "Add",
    "Boş Olamaz": "Cannot be empty",

    "Depo Silme Formu": "Warehouse Deletion Form",
    "Depo Silme Başarısız": "Warehouse Deletion Failed",
    "Depo Silme Başarılı": "Warehouse Deletion Successful",

    "warehouse not found or already deleted with id": "Warehouse not found or already deleted",

    "Depo Ekleme Başarısız": "Warehouse Addition Failed",
    "Depo Ekleme Başarılı": "Warehouse Addition Successful",
    "Depo Güncelleme Başarısız": "Warehouse Update Failed",
    "Depo Güncelleme Başarılı": "Warehouse Update Successful",

    "cannot create zone in inactive warehouse": "Cannot create zone in inactive warehouse",

    "Adı": "Name",
    "Geçerli": "Valid",
    "Bölge Kodu": "Region Code",
    "Bölge Adı": "Region Name",
    "Sevke Açık Bölge": "Shipping Open Region",

    "Bölge Tanım": "Region Definition",
    "Bölgeden Çıkışta Form Yazdır": "Print Form on Exit from Region",
    "Bölge Ekle": "Add Region",

    "Depo Tanımları": "Warehouse Definitions",
    "Bölge Tanımları": "Region Definitions",

    " adet kayıt başarılı bir şekilde eklendi.": " records have been successfully added.",

    "adet başarılı": "successful",
    "adet hatalı kayıt": "incorrect record",

    "araç tanımlandı": "vehicle defined",
    "araç güncellendi": "vehicle updated",
    "araçta hata oluştu": "error in vehicle",

    "Super Admin en kapsamlı roldür. Ek role ihtiyaç yok.": "Super Admin is the most comprehensive role. No additional role is needed.",
    "Girmiş olduğunuz Email sistem üzerinde aktif bir kullanıcıya aittir. Lütfen farklı bir Email giriniz.": "The Email you entered belongs to an active user in the system. Please enter a different Email.",

    "failed to check chassis number: vehicle not found": "Vehicle not found",

    "Adres Değiştirme": "Change Address",
    "Kriterler": "Criteria",
    "Koordiant": "Coordinate",
    "Yön": "Direction",
    "Sıra": "Row",

    "Bu koordinat ve yön için belirtilen sıra aralığı zaten mevcut": "The specified sequence range for this coordinate and direction already exists",
    "Yerinde Adresleme": "On-Site Addressing",

    "Ship unload has already been processed for this vehicle": "Ship unload has already been processed for this vehicle",

    "Vehicle must be of type 'ithal'": "Vehicle must be of type 'imported'",

    "EMPTY": "EMPTY",
    "FULL": "FULL",
    "PARTIALLY_FULL": "PARTIALLY FULL",
    "OUT OF USE": "OUT OF USE",
    "PDI order has not been issued": "PDI order has not been issued",
    "{address} adresi kullanımda olduğu için boş duruma ayarlanamaz": "Cannot set address {address} to empty: address is in use",
    "updateFailed": "Address Update Failed",
    "updateSuccess": "Address Update Successful",
    "selectAddress": "Please select an address",

    "boş olarak ayarlanamaz: Adres kullanımda": "Cannot be set to empty: Address in use",
    "Adres": "Address",

    "ship unload already processed": "Ship unload already processed",

    "vehicle is already domestic (milli)": "Vehicle is already domestic (milli)",

    "PASSENGER": "PASSENGER",
    "COMMERCIAL": "COMMERCIAL",
    "HEAVY_COMMERCIAL": "HEAVY COMMERCIAL",


    "location": "Location",
    "dealer_code": "Dealer Code",
    "company_title": "Company Title",
    "group_company_title": "Group Company Title",
    "brand_id": "Brand",
    "address_definition": "Address Definition",
    "latitude": "Latitude",
    "longitude": "Longitude",
    "phone1": "Phone 1",
    "distance": "Distance",
    "group_region_id": "Group Region",
    "standard_address_id": "Standard Address",
    "tax_office": "Tax Office",
    "tax_number": "Tax Number",
    "coordinates": "Coordinates",
    "phone": "Phone",
    "excel_data": "Excel Data",
    "aladin_code_name": "Aladin Code/Name",
    "aladin_code": "Aladin Code",
    "aladin_name": "Aladin Name",
    "tax_info": "Tax Information",
    "authorized_info": "Authorized Information",
    "email": "Email Information",
    "special_notes": "Special Notes",
    "is_active": "Active",
    "is_warehouse": "Warehouse Definition",
    "save": "Save",
    "cancel": "Cancel",
    "dealer_form": "Dealer Form",
    "field_required": "{field} is required",
    "error_loading_data": "Error loading data",
    "fill_required_fields": "Please fill in the required fields",
    "record_created": "Record created successfully",
    "record_updated": "Record updated successfully",
    "error_occurred": "An error occurred",

    "No dock permit found for this chassis": "No dock permit found for this chassis",

    "vehicle type: ithal, antrepo: false": "Imported (non-national) vehicles are only allowed to exit if they are located in the warehouse area. Vehicles outside the warehouse area cannot exit.",

    "failed to get groupage details: vehicle not found with the given groupage no": "Vehicle not found with the given groupage no",

    "Depo Yönetimi": "Warehouse Management",
    "Adresteki Araçları Boşalt": "Unload Vehicles at Address",
    "Park Şöförleri": "Parking Drivers",
    "Emir Tanımlama": "Order Definition",
    "Araç Yönetimi": "Vehicle Management",
    "Sevkiyat Tanımları": "Shipment Definitions",
    "Taseron Firmalar": "Subcontractor Companys",
    "Sevkiyat Yerleri": "Shipment Locations",
    "Sevk Bölgeleri": "Shipment Regions",
    "Adres Tanımları": "Address Definitions",
    "İl Tanımları": "Province Definitions",
    "İlçe Tanımları": "District Definitions",
    "Sevkiyat Tipi": "Shipment Type",
    "Rota Tanımları": "Route Definitions",
    "Sevkiyat KM Bilgileri": "Shipment KM Information",
    "Araç Markaları": "Vehicle Brands",
    "Model Tanımları": "Model Definitions",
    "Renk Tanımları": "Color Definitions",
    "Tanımlamalar": "Definitions",

    "Veri Yükleme": "Data Upload",
    "Şase Tanımlama": "VIN Definition",
    "Şase Uyarı Yükleme": "VIN Warning Upload",
    "Gemi Tahliye Bilgisi": "Ship Unloading Information",
    "Gümrüklendi Bilgisi": "Customs Information",
    "PDI Emir Girişi": "PDI Order Entry",

    "Fatura Verileri": "Invoice Data",
    "Önceliklendirme": "Prioritization",
    "Blokaj/Sevk Emri": "Blockage/Shipment Order",
    "Manuel Sevk Emri": "Manual Shipment Order",

    "Tekli Grupaj Tır Eşleme": "Single Groupage Truck Matching",
    "Gemi Tahliye": "Ship Unloading",
    "Gümrüklü Saha Çıkış": "Customs Area Exit",
    "Sevk Alanına Transfer": "Transfer to Shipment Area",

    "Depolar Arası Transfer Emri": "Inter-Warehouse Transfer Order",
    "Depolar Arası Transfer İzleme": "Inter-Warehouse Transfer Tracking",

    "Grupaj Hazırlama": "Groupage Preparation",
    "Grupaj İşlemleri": "Groupage Operations",

    "the order to unload the ship must be given first": "The ship must be evacuated first",

    "vehicle in antrepo zone but has no PDI order": "Vehicle in antrepo zone but has no PDI order",

    "chassis not found": "Chassis not found",
    "failed to check vehicle gorupage status and address: vehicle in groupage": "Vehicle in groupage",

    "failed to get chassis history": "Failed to get chassis history",
    "no history found for chassis number": "No history found for chassis number",

    "invalid chassis number length": "Invalid chassis number length",
    "must be 17 characters": "must be 17 characters",

    "COMPLETED": "COMPLETED",
    "WAITING": "WAITING",
    "no suitable address found": "No suitable address found",
    "failed to assignToStockArea: no suitable address found": "No suitable address found",

    "öncelikle tır onayı işlemi yapılmalıdır": "First, the Truck Approval process must be completed",
    "failed to parse address operations": "Failed to parse address operations",
    "unexpected end of JSON input": "Unexpected end of JSON input",

    "vehicle is active": "Vehicle is active in the warehouse",

    "from_warehouse_id": "From Warehouse",
    "to_warehouse_id": "To Warehouse",

    "transfer_date": "Transfer Date",
    "order_id": "Order ID",
    "customs_clearance.clearance_date:": "Customs Clearance Date",
    "customs_clearance.clearance_date": "Customs Clearance Date",

    "ship_unload.unload_date": "Ship Unload Date",
    "dock_permit.permit_date": "Dock Permit Date",

    "failed to get vehicle: vehicle not found": "Vehicle not found",
    "vehicle has no current address assignment": "Vehicle has no current address assignment",

    "failed to get reception zone: failed to get zone: no rows in result set": "This warehouse does not have a 'Reception' zone. Please check the details",
    "return.return_date": "Return Date",

    "failed to check vehicle: vehicle not found": "Vehicle not found",

    // Araç resepsiyon bölgesindedir. Ve sistemde tanımlı değildir.
    "vehicle is suspended": "Vehicle is in the reception area and is not defined in the system",
    "chassis need to be customs clearanced": "Chassis need to be customs clearanced",
    "data SHIP_UNLOAD warehouse_code error: failed to assign chassis to ship area: no rows in result set": "Vehicle is in the ship unloading area and is not defined in the system",

    "vehicle has already an order with status waiting": "Vehicle has already an order with status waiting",
    "no chassis found with number": "No chassis found with number",
    "vehicle is in groupage": "Vehicle is in groupage",


    "failed to assign chassis to ship area": "Failed to assign chassis to ship area",
    "no rows in result set": "No rows in result set",
    "warehouse assignment error: failed to assign chassis to ship area: no rows in result set": "Warehouse assignment error: Failed to assign chassis to ship area: No rows in result set",
    "failed to check requesting dealer: order is not from the requested dealer": "Failed to check requesting dealer: Order is not from the requested dealer",
    "failed to check requesting dealer": "Failed to check requesting dealer",
    "order is not from the requested dealer": "Order is not from the requested dealer",

    // Tanımlı olmayan bayi kodu
    "error.invalid_client_code": "Invalid dealer code",

    "PDI status is already YENİ": "The vehicle has a PDI order.",
    "merge error": "Merge error",
    "The vehicle's dock exit must be ensured": "The vehicle's dock exit must be ensured",
    "domestic vehicles are not allowed for dock enter": "Domestic vehicles are not allowed for dock enter",
    "failed to get vehicle data: vehicle not found": "Failed to get vehicle data: Vehicle not found",
    "no invoice or shipping order": "No invoice or shipping order",
    "tarih is required and cannot be empty": "Date is required and cannot be empty",
    "failed to transform data": "Data transformation error",
    "vehicle already has dock permit": "Vehicle already has dock permit",
    "updated": "Updated",
    "created": "Created",
}